import { Input } from '../Input/Input';
import FilterableSelect from '../Input/FilterableSelect';

// renders an Input or Select component on the filters form
const FilterField = ({
  label,
  field,
  value,
  options,
  onChange,
  onSearchChange,
  onDropdownOpen,
  isLoading,
  type = 'text',
  min,
  max,
  disabled,
  hideLabel,
  dataTestId,
  error,
}) => {
  if (options) {
    return (
      <FilterableSelect
        label={label}
        data={value}
        onChange={(value) => {
          onChange({ target: { name: field, value } });
        }}
        onSearchChange={onSearchChange}
        options={options}
        required
        isLoading={isLoading}
        onDropdownOpen={onDropdownOpen}
        onClear={
          typeof value !== 'undefined' && value !== null
            ? () => {
                onChange({ target: { name: field, value: null } });
              }
            : null
        }
        disabled={disabled}
        dataTestId={dataTestId}
      />
    );
  }

  return (
    <>
      <Input
        label={label}
        hideLabel={hideLabel}
        type={type}
        name={field}
        value={value || ''}
        onChange={onChange}
        min={min}
        max={max}
        disabled={disabled}
        data-testid={dataTestId}
        error={error}
      />
    </>
  );
};

export default FilterField;
